/**
* Component: Nosto
* Corrects the discount pricing in the Nosto recommended products after they have loaded.
*/

import 'slick-carousel'
import log from 'salvo-lite/log'
import { formatMoney } from '@shopify/theme-currency'
import { percentageSaving, on } from '../helpers/utils'
import jQuery from 'jquery'

class Nosto {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        log.debug(this.constructor.name, 'Constructed', this)

        this._selectors = {
            product: '[data-nosto-product]',
            price: '[data-nosto-price]',
            discount: '[data-nosto-discount]',
            priceWrapper: '[data-nosto-price-wrapper]'
        }

        this._nodeSelectors = {
            products: [],
            priceWrapper: null
        }

        /**
         * Properties
         */
        this._dataLayerHighlightedProductIDsSent = false

        this._handleCarousel()
    }

    onInit () {
        this._load()
    }

    /**
     * Listens for changes in the Nosto element
     */
    _load () {
        const config = { attributes: true, childList: true, subtree: true }
        const callback = (mutationsList, observer) => {
            mutationsList.forEach(mutation => {
                if (mutation.addedNodes.length) {
                    mutation.addedNodes.forEach((node) => {
                        if (node.classList.contains('nr__products')) {
                            this._setNodeSelectors()
                            this._updatePrice()
                            this._setListeners()
                            this._dataLayerHighlightedProductIDs()
                            // observer.disconnect()
                        }
                    })
                }
            })
        }

        const observer = new MutationObserver(callback)

        observer.observe(this._elem, config)
    }

    /**
     * Sets node selectors after Nosto has loaded.
     */
    _setNodeSelectors () {
        this._nodeSelectors.priceWrapper = this._elem.querySelectorAll(this._selectors.priceWrapper)
        this._nodeSelectors.products = this._elem.querySelectorAll(this._selectors.product)
    }

    /**
     * Set Listeners
     */
    _setListeners () {
        this._nodeSelectors.products.forEach((product) => {
            if (!product.classList.contains('bind')) {
                on('click', product, (e) => this._dataLayerHighlightedProductClick(e))
                product.classList.add('bind')
            }
        })
    }

    /**
     * Fetches pricing from data attributes.
     */
    _updatePrice () {
        this._nodeSelectors.priceWrapper.forEach((wrapper) => {
            const price = wrapper.getAttribute('data-nosto-price')
            const discount = wrapper.getAttribute('data-nosto-discount')
            wrapper.innerHTML = this._getPriceHtml(price, discount)
        })
    }

    /**
     * Returns the pricing HTML.
     * @param {float} price
     * @param {float} discount
     */
    _getPriceHtml (price, discount) {
        const discountedPrice = (parseFloat(price) + parseFloat(discount))
        const percentageOff = percentageSaving(price, discountedPrice)
        let discountHtml = ''

        if (discount !== null) {
            discountHtml = `
            <div class="nr__product-compareprice">${formatMoney(discountedPrice * 100, window.theme.moneyFormat)}</div>
            <div class="nr__product-discount">(${percentageOff}${window.theme.strings.percentageOff})</div>`
        }

        return `<div class="nr__product-saleprice">${formatMoney(price * 100, window.theme.moneyFormat)}</div>${discountHtml}`
    }

    /**
     * Send data in the following format containing product IDs: 12345-12345-12345-12345
     */
    _dataLayerHighlightedProductIDs () {
        if (!this._dataLayerHighlightedProductIDsSent) {
            let productIDString = ''

            this._nodeSelectors.products.forEach((product) => {
                productIDString += `${product.getAttribute('data-product-id')}-`
            })

            productIDString = productIDString.substring(0, productIDString.length - 1)

            window.dataLayer.push({
                event: 'highlighedProductsShown',
                itemIDs: productIDString
            })
        }

        this._dataLayerSent = true
    }

    /**
     * Push the clicked highlighted product ID to the datalayer
     */
    _dataLayerHighlightedProductClick (e) {
        const productID = e.currentTarget.getAttribute('data-product-id')

        window.dataLayer.push({
            event: 'highlighedProductClicked',
            itemID: productID
        })
    }

    /**
     * Checks if the Nosto element is a carousel and initializes it.
     * @returns {void}
     */
    _handleCarousel() {
        const containerElement = document.querySelectorAll('[data-caoursel]')
        if (!containerElement) {
            return;
        }

        for (let element of containerElement) {

            const targetNostoNode = element.querySelector('.nosto_element')
            const config = { attributes: false, childList: true, subtree: false }

            const callback = function(mutationsList, observer) {
                for(let mutation of mutationsList) {
                    if (mutation.type === 'childList') {

                        const carouselTarget = targetNostoNode.querySelector(`.nosto-list`);

                        jQuery(carouselTarget).slick({
                            infinite: true,
                            slidesToShow: 4,
                            slidesToScroll: 1,
                            dots: false,
                            arrows: true,
                            prevArrow: "<div class='slick-prev'></div>",
                            nextArrow: "<div class='slick-next'></div>",
                            responsive: [
                                {
                                    breakpoint: 1440,
                                    settings: {
                                        slidesToShow: 3,
                                        slidesToScroll: 1
                                    }
                                },
                                {
                                    breakpoint: 1024,
                                    settings: {
                                        slidesToShow: 2,
                                        slidesToScroll: 1
                                    }
                                },
                                {
                                    breakpoint: 480,
                                    settings: {
                                        slidesToShow: 1,
                                        slidesToScroll: 1
                                    }
                                }
                            ]
                        });
                        observer.disconnect();
                        break;
                    }
                }
            };

            const observer = new MutationObserver(callback);

            observer.observe(targetNostoNode, config);
        }
    }
}

export default Nosto



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Nosto.js